import React, { useState } from "react";
import { Sidebar } from '../Elements/Sidebar';
import logo from '../../assets/logoasf.png';

export const Header = () => {

    const [show, setShow] = useState(false);

    return (
        <header className="bg-base-100 shadow-xl sticky top-0 z-10">
            <div className="bg-accent">
                <a href="/location" className="text-white text-center py-1 block">Nouveau : Location mini-pelle ! </a>
            </div>
            <div className="navbar">
                <div className="navbar-start">
                    <a href="/" className="ml-2">
                        <img
                            src={logo}
                            alt="logo asf terrassement noir"
                            width={100}
                        />
                    </a>
                </div>
                <div className="navbar-center">
                    <ul className=" gap-8 justify-center items-center xl:flex xl:flex-row hidden">
                        <li><a href="/nos-services/10005">Démolition</a></li>
                        <li><a href="/nos-services/10001">Terrassement</a></li>
                        <li><a href="/nos-services/10002">Assainissement</a></li>
                        <li><a href="/nos-services/10003">Aménagement extérieur</a></li>
                        <li><a href="/nos-services/10004">Évacuation</a></li>
                        <li><a href="/nos-services/10006">Paysagisme</a></li>
                        <li><a href="/nos-services/10007">Viabilisation</a></li>
                        <li><a href="/nos-services/10008">Vide-Maison</a></li>
                        <li><a href="/contact">Contact</a></li>
                    </ul>
                    <div className='xl:hidden flex flex-row gap-1 justify-center items-center bg-base-100'>
                        <button className="btn btn-primary rounded-full mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
                            </svg>
                            <a href="tel:+33698009233">06 98 00 92 33</a>
                        </button>
                    </div>
                </div>
                <div className="navbar-end">
                    <div className='dropdown dropdown-left'>
                        <button onClick={() => setShow(!show)} className="btn btn-square btn-ghost xl:hidden">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                className="inline-block h-5 w-5 stroke-current">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
                            </svg>
                        </button>
                    </div>
                    <div className="xl:flex hidden gap-1">
                        <button className="btn btn-primary rounded-full">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
                            </svg>
                            <a href="tel:+33698009233">06 98 00 92 33</a>
                        </button>
                    </div>
                </div>
            </div>

            {show && <Sidebar setShow={setShow} />}

        </header>
    );
};

export default Header;